import { createModule, mutation } from 'vuex-class-component';
import { CreateContractModel } from '@/models/contractDetailsModel';
import { StepData, StepperModel, StepStatus } from '../models/StepperModel';

const VuexModule = createModule({
  namespaced: 'Stepper',
  strict: false,
  target: 'nuxt',
});
export default class StepperStore extends VuexModule {
  private Contract: CreateContractModel = {} as CreateContractModel;
  specialty = 'JavaScript';
  stepperModel: StepperModel = {
    isHide: true,
    firstPartnerStep: {
      title: 'بيانات الأطراف',
      stepClass: 'active-step',
      order: 1,
      status: StepStatus.active,
    } as StepData,
    contractDurationStep: {
      title: 'مدة العقد',
      stepClass: 'next-step',
      order: 2,
      status: StepStatus.next,
    } as StepData,
    contractDataStep: {
      title: 'بيانات العقد',
      stepClass: 'next-step',
      order: 3,
      status: StepStatus.next,
    } as StepData,
    reviewStep: {
      title: 'معاينة وإرسال الطلب',
      stepClass: 'next-step',
      order: 4,
      status: StepStatus.next,
    } as StepData,
  } as StepperModel;

  get getSteps() {
    return this.stepperModel;
  }

  @mutation hideStepper(isHide: boolean) {
    this.stepperModel.isHide = isHide;
  }

  @mutation setActiveFirstPartnerStep() {
    this.stepperModel.isHide = false;
    this.stepperModel.firstPartnerStep.status = StepStatus.active;
    this.stepperModel.firstPartnerStep.stepClass = 'active-step';

    this.stepperModel.contractDurationStep.status = StepStatus.next;
    this.stepperModel.contractDurationStep.stepClass = 'next-step';

    this.stepperModel.contractDataStep.status = StepStatus.next;
    this.stepperModel.contractDataStep.stepClass = 'next-step';

    this.stepperModel.reviewStep.status = StepStatus.next;
    this.stepperModel.reviewStep.stepClass = 'next-step';
  }

  @mutation setActiveContractDurationStepStep() {
    this.stepperModel.isHide = false;
    this.stepperModel.firstPartnerStep.status = StepStatus.done;
    this.stepperModel.firstPartnerStep.stepClass = 'finished-step';

    this.stepperModel.contractDurationStep.status = StepStatus.active;
    this.stepperModel.contractDurationStep.stepClass = 'active-step';

    this.stepperModel.contractDataStep.status = StepStatus.next;
    this.stepperModel.contractDataStep.stepClass = 'next-step';

    this.stepperModel.reviewStep.status = StepStatus.next;
    this.stepperModel.reviewStep.stepClass = 'next-step';
  }

  @mutation setActiveContractDataStep() {
    this.stepperModel.isHide = false;
    this.stepperModel.firstPartnerStep.status = StepStatus.done;
    this.stepperModel.firstPartnerStep.stepClass = 'finished-step';

    this.stepperModel.contractDurationStep.status = StepStatus.done;
    this.stepperModel.contractDurationStep.stepClass = 'finished-step';

    this.stepperModel.contractDataStep.status = StepStatus.active;
    this.stepperModel.contractDataStep.stepClass = 'active-step';

    this.stepperModel.reviewStep.status = StepStatus.next;
    this.stepperModel.reviewStep.stepClass = 'next-step';
  }

  @mutation setActiveReviewContractStep() {
    this.stepperModel.isHide = false;
    this.stepperModel.firstPartnerStep.status = StepStatus.done;
    this.stepperModel.firstPartnerStep.stepClass = 'finished-step';

    this.stepperModel.contractDurationStep.status = StepStatus.done;
    this.stepperModel.contractDurationStep.stepClass = 'finished-step';

    this.stepperModel.contractDataStep.status = StepStatus.done;
    this.stepperModel.contractDataStep.stepClass = 'finished-step';

    this.stepperModel.reviewStep.status = StepStatus.active;
    this.stepperModel.reviewStep.stepClass = 'active-step';
  }

  getClass(stepType: StepType) {
    let stepClass = '';
    switch (stepType) {
      case StepType.first:
        if (this.stepperModel.firstPartnerStep.status === StepStatus.active) {
          stepClass = 'active-step';
        }

        break;

      default:
    }
    return stepClass;
  }
}

export enum StepType {
  first = 1,
  secod = 2,
  third = 3,
  fourth = 4
}
